import { render, staticRenderFns } from "./optometrist.vue?vue&type=template&id=7c48a38c&scoped=true&"
import script from "./optometrist.vue?vue&type=script&lang=js&"
export * from "./optometrist.vue?vue&type=script&lang=js&"
import style0 from "./optometrist.vue?vue&type=style&index=0&id=7c48a38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48a38c",
  null
  
)

export default component.exports